module.exports = __webpack_public_path__ + "static/img/no_img.7ad410e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_img.jpg
// module id = gEB/
// module chunks = 55